import { Navigate } from "react-router-dom";
import { useContext } from "react"
import { AuthContext } from "../context/auth/AuthProvider"
/**
 * Comprueba si el usuario está logeado
 * @returns Redirecciona al login si no está logeado y si lo está renderiza la vista pedida
 */
const PrivateKitchenRouter = ({children}) => {
    const { client } = useContext(AuthContext)

    if (!client || client.rol !== "Kitchen") {
        return <Navigate to="/" replace />
    }

    return children
    
}

export default PrivateKitchenRouter;